<template>
  <v-main>
    <v-container class="fill-height">
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
        >
          <v-card
            color="secondaryMaster"
            class="elevation-12"
          >
            <v-toolbar
              dark
              color="primary"
            >
              <v-toolbar-title class="px-4">Albatross</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="login-card-text">
              <h2
                v-if="userStore.loginError"
                class="text-error"
              >
                {{ userStore.loginError }}
              </h2>
              <v-form
                ref="login"
                v-model="validForm"
                @submit.prevent="onSubmit()"
              >
                <a-text-field
                  v-model="form.email"
                  required
                  color="primary"
                  :rules="requiredRules"
                  prepend-icon="mdi-account"
                  name="login"
                  label="Login"
                  type="email"
                  autocomplete="username"
                />
                <a-text-field
                  id="password"
                  v-model="form.password"
                  required
                  color="primary"
                  :rules="requiredRules"
                  prepend-icon="mdi-lock"
                  name="password"
                  label="Password"
                  type="password"
                  autocomplete="current-password"
                />
                <v-card-actions>
                  <router-link
                    :to="'/forgotPassword'"
                    title="Forgot Password"
                    class="text-anchor body-large"
                  >
                    Forgot Password
                  </router-link>
                  <v-spacer />
                  <a-btn
                    variant="flat"
                    :loading="loginLoading"
                    type="submit"
                    text="Login"
                  />
                </v-card-actions>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script setup>
import constants from '@/helpers/constants'
import axios from 'axios'
import { onMounted, ref } from 'vue'

import { useUserStore } from '@/stores/UserStore.js'
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()

const userStore = useUserStore()

const validForm = ref(false)
const form = ref({
  email: null,
  password: null
})
const loginLoading = ref(false)
const requiredRules = ref(constants.BASIC_REQUIRED_RULE)
const login = ref(null)

onMounted(() => {
  userStore.loginError = ''
})

const onSubmit = async () => {
  loginLoading.value = true
  if (login.value.validate()) {
    try {
      const params = {
        username: form.value.email,
        password: form.value.password
      }
      const { data } = await axios.post(
        `${constants.VUE_APP_BASE_API}/auth/login`,
        params
      )
      const { token, details } = data
      if (token) {
        userStore.jwt = token
        loginSuccess(details)
      } else {
        loginLoading.value = false
        userStore.loginError = 'Invalid Username or Password.'
      }
    } catch (e) {
      loginLoading.value = false
      userStore.loginError = e.data

      if (e?.status === 406) {
        // This means the user tried to login with the company default password. Redirect to the reset password screen.
        router.push({ path: `/resetPassword` })
      }
    }
  } else {
    loginLoading.value = false
  }
}
const loginSuccess = async (details) => {
  await userStore.login(details)

  //this code handles redirecting them back to the page they were trying to get to after they login
  let rt = { name: 'home' }
  if (route.query?.redirect) {
    rt = { path: route.query?.redirect }
  }
  await router.push(rt)
}
</script>

<style scoped lang="scss">
.logo {
  max-width: 100%;
}

@media (min-width: 769px) {
  .login-card-text {
    padding: 65px;
  }
}
</style>
